import { GoogleMap, StreetViewPanorama } from '@react-google-maps/api';
import React, { Component } from 'react';
import classes from './AutocompleteMap.module.css';
import IconMapMarker from 'components/Maps/IconMapMarker/IconMapMarker';

const streetViewPanoramaOptions = {
  zoomControl: true,
  controlSize: true,
  clickToGo: false,
  addressControl: false,
  mapTypeControl: false,
  scaleControl: true,
  panControl: false,
  linksControl: false,
  enableCloseButton: false,
  streetViewControl: false,
  rotateControl: false,
  scrollwheel: false,
  fullscreenControl: false,
};

class AutocompleteMap extends Component {
  constructor(props) {
    super(props);
    this.map = React.createRef();
    this.streetView = React.createRef();
  }

  zoomChanged = () => {
    if (this.map.current) {
      const updatedZoom = this.map.current.state.map.zoom;
      this.props.handleLocationUpdate(null, null, null, null, updatedZoom, null, null, null);
    }
  };

  centerChanged = () => {
    if (this.map.current) {
      const center = { lat: this.map.current.state.map.center.lat(), lng: this.map.current.state.map.center.lng() };
      this.props.handleLocationUpdate(null, null, null, center, null, null, null, null);
    }
  };

  povChanged = () => {
    if (this.streetView.current) {
      const heading = this.streetView.current.state.streetViewPanorama.pov.heading;
      const pitch = this.streetView.current.state.streetViewPanorama.pov.pitch;
      if (heading !== this.props.heading || pitch !== this.props.pitch) {
        this.props.handleLocationUpdate(null, null, null, null, null, null, pitch, heading);
      }
    }
  };

  handleMapTypeChange = (mapTypeId) => {
    if (this.map.current) {
      const zoom = mapTypeId === 'streetview' ? 1 : this.map.current.state.map.mapTypeId === 'streetview' ? 15 : this.map.current.state.map.zoom;
      const pitch = mapTypeId === 'streetview' ? 1 : this.map.current.state.map.pitch;
      const heading = mapTypeId === 'streetview' ? 298 : this.map.current.state.map.heading;
      this.props.handleLocationUpdate(null, null, null, null, zoom, mapTypeId, pitch, heading);
    }
  };

  render = () => {
    const mapContainerStyle = {
      height: this.props.shortWindow ? '508px' : '569px',
      width: this.props.width,
      marginTop: '10px',
    };

    const mapControlOptions =
      this.props.mapTypeId === 'roadmap' ? ['satellite'] : this.props.mapTypeId === 'satellite' ? ['roadmap'] : ['roadmap', 'satellite'];
    if (this.props.address.length > 0 && (this.props.mapTypeId === 'roadmap' || this.props.mapTypeId === 'satellite'))
      mapControlOptions.push('streetview');
    const containerClasses = [classes.Container];
    if (this.props.shortWindow) containerClasses.push(classes.ShortWindow);

    return (
      <div className={containerClasses.join(' ')}>
        <GoogleMap
          onLoad={this.onLoad}
          id="marker-example"
          ref={this.map}
          mapTypeId={this.props.mapTypeId}
          mapContainerStyle={mapContainerStyle}
          zoom={this.props.mapTypeId === 'streetview' ? 7 : this.props.zoom}
          center={this.props.center}
          defaultCenter={this.props.center}
          options={{
            mapTypeId: this.props.mapTypeId ? (this.props.mapTypeId === 'satellite' ? 'hybrid' : this.props.mapTypeId) : 'roadmap',
            fullscreenControl: false,
            streetViewControl: false,
            mapTypeControl: false,
            minZoom: 3,
            zoomControlOptions: { position: 9 },
          }}
          onZoomChanged={this.zoomChanged}
          onDragEnd={this.centerChanged}
        >
          {this.props.mapTypeId === 'streetview' ? (
            <StreetViewPanorama
              ref={this.streetView}
              position={this.props.geoLocation}
              pov={{ pitch: this.props.pitch, heading: this.props.heading }}
              options={streetViewPanoramaOptions}
              onPovChanged={() => this.povChanged()}
              visible
            >
              {' '}
            </StreetViewPanorama>
          ) : (
            <IconMapMarker
              markerColor={this.props.markerColor}
              moveMarker={this.props.moveMarker}
              locationIcon={this.props.locationIcon}
              geoLocation={this.props.includeMarker ? this.props.geoLocation : null}
            />
          )}
        </GoogleMap>
        {this.props.locationSelected ? (
          <div className={classes.MapControls}>
            {mapControlOptions.map((mapTypeId) => (
              <button key={mapTypeId} onClick={() => this.handleMapTypeChange(mapTypeId)}>
                {mapTypeId === 'roadmap' ? 'MAP' : mapTypeId.toUpperCase()}
              </button>
            ))}
          </div>
        ) : null}
      </div>
    );
  };
}

export default AutocompleteMap;
